"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFormFieldRadio = void 0;
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));
var Radio_1 = __importDefault(require("@material-ui/core/Radio"));
var RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
var react_1 = __importStar(require("react"));
var APForm_1 = require("./APForm");
function APFormFieldRadio(_a) {
    var _this = this;
    var style = _a.style, label = _a.label, items = _a.items, onChanged = _a.onChanged, initialValue = _a.initialValue, helperText = _a.helperText, validator = _a.validator, control = _a.control;
    var foundIndex = items.findIndex(function (item) { return item.value === initialValue; });
    var control2 = react_1.useContext(APForm_1.APFormContext);
    if (control !== undefined) {
        control2 = control;
    }
    var _b = react_1.useState(foundIndex === -1 ? "" : foundIndex), value = _b[0], setValue = _b[1];
    var _c = react_1.useState(null), error = _c[0], setError = _c[1];
    function checkValues() {
        return __awaiter(this, void 0, void 0, function () {
            var errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorMessage = null;
                        if (!validator) return [3 /*break*/, 4];
                        if (!(value !== '')) return [3 /*break*/, 2];
                        return [4 /*yield*/, validator(items[value].value)];
                    case 1:
                        errorMessage = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, validator(null)];
                    case 3:
                        errorMessage = _a.sent();
                        _a.label = 4;
                    case 4:
                        setError(errorMessage);
                        return [2 /*return*/, !errorMessage];
                }
            });
        });
    }
    var fieldItem = {
        validate: checkValues,
        reset: function () {
            setValue(foundIndex === -1 ? "" : foundIndex);
        }
    };
    react_1.useEffect(function () {
        if (control2 !== undefined)
            control2.fields.add(fieldItem);
        return function () {
            if (control2 !== undefined)
                control2.fields.delete(fieldItem);
        };
    });
    react_1.useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(validator && error !== null)) return [3 /*break*/, 5];
                        errorMessage = null;
                        if (!(value !== '')) return [3 /*break*/, 2];
                        return [4 /*yield*/, validator(items[value].value)];
                    case 1:
                        errorMessage = _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, validator(null)];
                    case 3:
                        errorMessage = _a.sent();
                        _a.label = 4;
                    case 4:
                        setError(errorMessage);
                        _a.label = 5;
                    case 5:
                        if (onChanged) {
                            if (value !== '') {
                                onChanged(items[value].value);
                            }
                            else {
                                onChanged(null);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [value]);
    return react_1.default.createElement(FormControl_1.default, { margin: 'normal', variant: 'outlined', 
        // size='small'
        error: !!error, style: style },
        react_1.default.createElement(FormLabel_1.default, { component: "legend", style: { marginLeft: "8px", marginBottom: "8px" } }, label),
        react_1.default.createElement(RadioGroup_1.default, { value: value, onChange: function (v) {
                setValue(parseInt(v.target.value));
            } }, items.map(function (item, index) {
            return react_1.default.createElement(FormControlLabel_1.default, { key: index, style: { marginLeft: 0 }, value: index, control: react_1.default.createElement(Radio_1.default, { size: 'small', color: 'primary' }), label: item.label });
        })),
        react_1.default.createElement(FormHelperText_1.default, null, error || helperText));
}
exports.APFormFieldRadio = APFormFieldRadio;
